import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=20daa2e4&"
import script from "./EditMember.vue?vue&type=script&lang=js&"
export * from "./EditMember.vue?vue&type=script&lang=js&"
import style0 from "../../styles/vue-multiselect.css?vue&type=style&index=0&lang=css&"
import style1 from "../../styles/simple-suggest.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports